import React from 'react'
import { withRouter } from 'react-router'

import FilterSort, { parseQuery } from './filterSort'

import GlobalPropsProvider from '../utils/stateProvider'

import globalState from '../../helpers/globalState'
import { translate } from '../../helpers/stringTranslation'

import Styles from '../../styles/components/headerFilterSort.module.scss'
const { container, list } = Styles

class ArticleFilterSort extends FilterSort {
  queriesToGlobalState() {
    return {
      filter: 'articleFilter',
      sort: 'articleSort',
      archive: 'articleArchive',
    }
  }

  renderContent() {
    const { sort, filter, archive } = parseQuery(this.props.location.search, {
      filter: null,
      sort: null,
      archive: null,
    })

    const filterOptions = [
      {
        label: translate('all'),
        value: null,
      },
      ...globalState.state.articleCategories
        .filter(category => category.lang === this.props.language)
        .map(category => ({
          label: category.label,
          value: category.slug,
        })),
    ]

    const sortOptions = [
      {
        label: translate('newest'),
        value: null,
      },
      {
        label: translate('oldest'),
        value: 'oldest',
      },
      {
        label: translate('most_popular'),
        value: 'most-popular',
      },
    ]

    return (
      <div className={container}>
        <ul className={list}>
          {this.renderOptions(filterOptions, filter, 'articleFilter', 'filter')}
        </ul>
        <ul className={list}>
          {this.renderOptions(sortOptions, sort, 'articleSort', 'sort')}
        </ul>
      </div>
    )
  }
}

export default GlobalPropsProvider(withRouter(ArticleFilterSort), state => ({
  filter: state.articleFilter,
  sort: state.articleSort,
  archive: state.articleArchive,
  language: state.language,
}))



// WEBPACK FOOTER //
// ./src/components/header/articleFilterSort.js